import { createAsyncThunk } from "@reduxjs/toolkit";
import InterviewsAPI, { CreateInterviewRequest, Interview, UpdateInterviewRequest } from "../api/Interviews";

export const createInterview = createAsyncThunk<
    Interview[],
    CreateInterviewRequest,
    {rejectValue: void}
>(
    'interview/create',
    async (request, {rejectWithValue}) => {
        try{
            await InterviewsAPI.create(request);
            return request.interviews;
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)

export const updateInterview = createAsyncThunk<
    void,
    {caseId: string, id: string, request: UpdateInterviewRequest},
    {rejectValue: void}
>(
    'interview/update',
    async ({caseId, id, request}, {rejectWithValue}) => {
        try{
            await InterviewsAPI.update(caseId, id, request);
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)